import { Link } from 'react-router-dom';
import type { Inspection } from '../../types';
import { formatDistanceToNow } from '../../lib/time';

const statusPalette: Record<Inspection['status'], string> = {
  draft: 'bg-muted text-muted-foreground',
  in_progress: 'bg-warning/20 text-warning',
  completed: 'bg-success/20 text-success'
};

export function ItemList({ inspections }: { inspections: Inspection[] }): JSX.Element {
  return (
    <div className="glass-card divide-y divide-white/10">
      {inspections.map((inspection) => (
        <div key={inspection._id} className="flex flex-col gap-2 px-4 py-4 sm:flex-row sm:items-center sm:justify-between">
          <div>
            <p className="text-sm font-medium text-foreground">{typeof inspection.propertyId === 'string' ? inspection.propertyId : inspection.propertyId.name}</p>
            <p className="text-xs text-muted-foreground">
              Updated {formatDistanceToNow(inspection.updatedAt)} • {inspection.rooms.length} rooms captured
            </p>
          </div>
          <div className="flex items-center gap-3">
            <span className={`rounded-full px-2.5 py-1 text-xs font-medium ${statusPalette[inspection.status]}`}>
              {inspection.status.replace('_', ' ')}
            </span>
            <Link
              to={`/app/items/${inspection._id}`}
              className="focus-ring inline-flex items-center rounded-full border border-primary/40 px-3 py-1.5 text-xs font-medium text-primary transition hover:bg-primary/10"
            >
              Open detail
            </Link>
          </div>
        </div>
      ))}
    </div>
  );
}
